<template>
  <div class="ws-orgs">
    <ws-orgs-filter @change="onFilter" :filter.sync="filter" :is-enabled.sync="isFilterEnabled" ref="filter" />
    <section class="ws-orgs__content">
      <ws-list-view class="ws-orgs__list"
                    :class="{ 'is-pending':isPending, 'is-loading':isFindPending }"
                    :data="list"
                    :header="false"
                    :detailed="false">
        <template slot="empty" v-if="isFilterEnabled">{{$t('Результатов, подходящих под выбранные фильтры не найдено.')}}</template>
        <template slot-scope="props">
          <ws-orgs-list-item :item="props.row" :curators="curators[props.row.guid]" />
        </template>
      </ws-list-view>
    </section>
    <footer class="ws-orgs__footer">
      <ws-pagination
        @change="onPageChange"
        :align="'right'"
        :totalItems="pagination.total"
        :itemsPerPage="pagination.per_page"
        :disabled="isPending"
        :currentIndex="pagination.current_page - 1">
      </ws-pagination>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import listMixin from '@/mixins/list.mixin'

const nullGuid = '00000000-0000-0000-0000-000000000000'

export default {
  name: 'WsOrgsList',
  mixins: [ listMixin ],
  data () {
    return {
      ready: 0,
      curators: []
    }
  },
  watch: {
    ready (value) {
      if (value > 0) {
        this._fetch()
      }
    }
  },
  computed: {
    ...mapState('public/refbook/education/institution', {
      isFindPending: 'isFindPending',
      pagination: 'pagination'
    }),
    ...mapGetters('public/refbook/education/institution', {
      list: 'list'
    })
  },
  methods: {
    ...mapActions('public/refbook/education/institution', ['find']),
    ...mapActions('refbook/curators', {
      'findCurators': 'create'
    }),
    ...mapMutations('public/refbook/education/institution', ['clearAll']),
    async _fetch () {
      this.clearAll()
      await this.find({ query: { k: this.keyword, page: this.page, per_page: this.per_page, ...this.filter } })

      const guids = this.list.filter(item => item.guid !== nullGuid && item.guid).map(elem => elem.guid)

      if (guids.length > 0) {
        this.curators = await this.findCurators([ guids, '/list' ])
      }
    }
  },
  created () {
    const unwatchFilter = this.$watch('filter', function () {
      this.ready++
      unwatchFilter()
    })
  }
}
</script>
